export { ConfirmationModal } from "./confirmation-modal";
export type {
	ConfirmationModalProps,
	ConfirmationModalItem,
	ConfirmationModalAction,
} from "./confirmation-modal";
